import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from 'vue'

import { useGenerator } from './useGenerator'
import { WIDGETS_MAP } from './widgets'


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterUi',
  props: {
    disabled: { type: Boolean },
    value: {},
    filters: {},
    permanent: {}
  },
  emits: ["input", "filtrate"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit

const props = __props

function update(newValue: any) {
  emit('input', { ...props.value, ...newValue })
}

const localValue = ref(props.value)
const { nodes } = useGenerator(
  {
    widgetsMap: WIDGETS_MAP,
    filters: props.filters,
    keyGetter: (k: any) => k.id,
    onApply: update,
  },
  localValue
)

watch(
  () => props.value,
  (newVal: any) => {
    if (JSON.stringify(newVal) !== JSON.stringify(localValue.value)) {
      emit('filtrate', newVal)
    }
    localValue.value = newVal || {}
  },
  { deep: true }
)

// const parameters = computed(() => ({
//   disabled: props.disabled,
//   values: props.value,
//   size: 'md',
// }))

const __returned__ = { emit, props, update, localValue, nodes, watch, ref, get useGenerator() { return useGenerator }, get WIDGETS_MAP() { return WIDGETS_MAP } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})